(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminWebhookDisplaySettingsController', AdminWebhookDisplaySettingsController);

    function AdminWebhookDisplaySettingsController(
        $controller,
        lodash,
        settingsCollection,
        siteAssociateTypesCollection,
        $translate,
        recurrenceRulesService,
        assetScoreTypesCollection,
        contractManager,
        elbSettings,
        $state,
        module,
        modulesService,
        fileTypeService
    ) {
        const vm = this;
        vm.quotesModuleEnabled = modulesService.isEnabled('quotes');

        const base = $controller('AdminDisplaySettingsController', {
            lodash: lodash,
            settingsCollection: settingsCollection,
            settingsFields: [
                'webhook_job',
                ...(modulesService.isEnabled('quotes') ? ['webhook_quote'] : [])
            ],
            siteAssociateTypesCollection: siteAssociateTypesCollection,
            $translate: $translate,
            recurrenceRulesService: recurrenceRulesService,
            assetScoreTypesCollection: assetScoreTypesCollection,
            contractManager: contractManager,
            elbSettings: elbSettings,
            $state: $state,
            module: module,
            modulesService: modulesService,
            fileTypeService: fileTypeService
        });

        angular.extend(vm, base);
    }
})();
